import React from 'react';
import { Box } from '@mui/material';

/**
 * Ikona Material Symbols Outlined — spójna z resztą aplikacji (font ładowany globalnie).
 * Używamy stylu z toolbaru EasyEstimate, żeby utrzymać jednolity wygląd.
 */
export const MaterialSymbol: React.FC<{
  name: string;
  size?: number;
  color?: string;
  fill?: boolean;
}> = ({ name, size = 22, color = '#5F6368', fill = false }) => (
  <Box
    component="span"
    className="material-symbols-outlined"
    sx={{
      fontFamily: '"Material Symbols Outlined"',
      fontSize: size,
      width: size,
      height: size,
      lineHeight: 1,
      display: 'inline-flex',
      alignItems: 'center',
      justifyContent: 'center',
      color,
      fontVariationSettings: `"FILL" ${fill ? 1 : 0}, "wght" 400, "GRAD" 0, "opsz" ${size}`,
      WebkitFontSmoothing: 'antialiased',
      MozOsxFontSmoothing: 'grayscale',
      textRendering: 'geometricPrecision',
      userSelect: 'none',
    }}
    aria-hidden
  >
    {name}
  </Box>
);

export const toolbarIconButtonSx = {
  width: 32,
  height: 32,
  borderRadius: '4px',
  p: 0,
  transition: 'background-color 0.15s ease',
  '&:hover': { bgcolor: 'rgba(0,0,0,0.06)' },
} as const;

export default MaterialSymbol;
